import { Component, inject } from '@angular/core';
//import { GsapService } from '../../core/services/gsap.service';
import { MasterService } from '../../core/services/master.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { eClick } from '../../core/services/entities';
import { HaylieService } from '../../core/services/haylie.service';

@Component({
  selector: 'app-track.component',
  imports: [FontAwesomeModule],
  templateUrl: './track.component.html',
  styleUrl: './track.component.scss',
})
export class TrackComponent {
  faArrow = faArrowRight;
  faWhatsapp=faWhatsapp;

  //private gsap = inject(GsapService);
  private _svc_haylie = inject(HaylieService);
  private _svc_master = inject(MasterService);

  navigate(p_to:string): void {

    switch(p_to) {

      case "regclick":
        var click = new eClick();
        this._svc_haylie.send_click(click); 
        break;

      default: 
        this._svc_master.navigate(p_to); 
      break;
    }
    
    
  }
}
